<template>
    <div>
        <h2>{{$t('screening-upload.verify.headline')}}</h2>
        <p class="text" v-if="!withoutNemId">{{$t('screening-upload.verify.description')}}</p>
        <p class="text" v-else>{{$t('screening-upload.withoutnemid.description')}}</p>
        <div class="seperator"></div>
        <div class="steps-top" v-if="!withoutNemId">
            <div  class="col first"
                  v-bind:class="{ finished: done || (!showNemId&&!validationSuccessful&&!done), finish: !showNemId&&validationSuccessful, active: showNemId }"
            >
                <div>
                    <div class="circle"><span>1</span></div>
                    <label>NemID</label>
                </div>
            </div>
            <div class="col second"
                 v-bind:class="{ finished: done || validationSuccessful || isVerified, active: !showNemId&&!validationSuccessful }"
            >
                <div>
                    <div class="circle"><span>2</span></div>
                    <label>CPR</label>
                </div>
            </div>
            <div class="col third"
                  v-bind:class="{ finished: done||(!showNemId&&validationSuccessful) }"
            >
                <div>
                    <div class="circle"><span>3</span></div>
                    <label>{{$t('label.verified')}}</label>
                </div>
            </div>
        </div>

        <div class="steps">
            <div v-if="!done && showNemId && !withoutNemId">
                <div class="step nemid">
                    <p class="label">{{$t('screening-upload.verify.nemid')}}</p>
                    <!-- STEP 1 - NEM ID VERIFICAITON HERE -->

                    <nemid-signature
                        id="nemid_iframe"
                        v-if="jsConfig"
                        width="300"
                        height="275"
                        :src="nemid_js_endpoint"
                        :config="jsConfig"
                        :show-loader="false"
                        @success="success"
                        @error="error"
                    >
                    </nemid-signature>

                    <button class="button purple" v-on:click="withoutNemId = true;">{{ $t('button.label.i-dont-have-nemid') }}</button>
                 </div>
            </div>

            <ExpatVerification v-if="!done && withoutNemId" />

            <div v-if="!done && !showNemId&&!validationSuccessful">
            <!-- <div> -->
                <div class="step">
                    <p class="label">{{$t('screening-upload.verify.cpr.label')}}</p>
                    <p>{{$t('screening-upload.verify.cpr.text')}}</p>
                    <!-- STEP 2 - CPR -->
                    <div class="cpr-input">
                        <form class="cpr-form">
                            <input
                                type="text"
                                maxlength="1"
                                class="first"
                                :class="{ active: isActiveEmail }"
                                placeholder="D"
                                autofill="off"
                                autocomplete="false"
                                v-on:keyup="$event.target.nextElementSibling.focus()"
                                v-model="cprNumber_1_1"
                                autofocus
                            >
                            <input type="text" maxlength="1" placeholder="D" autofill="off" autocomplete="false" v-on:keyup="$event.target.nextElementSibling.focus()" v-model="cprNumber_1_2">
                            <input type="text" maxlength="1" placeholder="M" autofill="off" autocomplete="false" v-on:keyup="$event.target.nextElementSibling.focus()" v-model="cprNumber_1_3">
                            <input type="text" maxlength="1" placeholder="M" autofill="off" autocomplete="false" v-on:keyup="$event.target.nextElementSibling.focus()" v-model="cprNumber_1_4">
                            <input type="text" maxlength="1" placeholder="Å" autofill="off" autocomplete="false" v-on:keyup="$event.target.nextElementSibling.focus()" v-model="cprNumber_1_5">
                            <input type="text" maxlength="1" placeholder="Å" autofill="off" autocomplete="false" v-on:keyup="$event.target.nextElementSibling.focus()" v-model="cprNumber_1_6">

                            <input type="text" maxlength="1" class="with-seperator" placeholder="1" autofill="off" autocomplete="false" v-on:keyup="$event.target.nextElementSibling.focus()" v-model="cprNumber_2_1">
                            <input type="text" maxlength="1" placeholder="2" autofill="off" autocomplete="false" v-on:keyup="$event.target.nextElementSibling.focus()" v-model="cprNumber_2_2">
                            <input type="text" maxlength="1" placeholder="3" autofill="off" autocomplete="false" v-on:keyup="$event.target.nextElementSibling.focus()" v-model="cprNumber_2_3">
                            <input type="text" maxlength="1" placeholder="4" autofill="off" autocomplete="false" v-on:keyup="$event.target.nextElementSibling.focus()" v-model="cprNumber_2_4">
                        </form>
                        <!-- <form>
                            <input type="text" v-model="cprNumber_1" maxlength="6" class="first" placeholder="DDMMÅÅ" autofill="off" autocomplete="false">
                            <span></span>
                            <input type="text" v-model="cprNumber_2" maxlength="4" class="last" placeholder="1234" autofill="off" autocomplete="false">
                        </form> -->
                    </div>
                    <!-- :disabled="cprDisabled || verifying" -->
                    <button class="button purple" :disabled="cprDisabled || verifying" @click.prevent="verifyPerson">
                        <span v-if="!verifying">{{$t('button.label.verification')}}</span>
                        <span v-if="verifying">{{$t('button.label.verification-loader')}}</span>
                    </button>
                </div>
            </div>

            <div v-if="validationSuccessful || done == '1' || done == 1">
                <div class="step">
                    <!-- STEP 3 - SUCCESS -->
                    <div class="box">
                        <simple-svg
                            :filepath="'images/SVG/Success.svg'"
                            :height="'100px'"
                            :width="'100px'"
                        />
                        <div class="content">
                            <p>{{$t('screening-upload.verify.success')}}</p>
                        </div>
                    </div>
                    <div class="seperator"></div>
                    <a href="#occupation"><button class="purple">{{$t('button.continue')}}</button></a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import {mapGetters} from 'vuex';
    import ExpatVerification from './ExpatVerification.vue';
    import NemidSignature from "../../../vue-nemid/components/NemidSignature";
    import Loader from "../../../components/Loader";


    export default {
        props: [
            'done',
            'expat',
        ],
        data: () => ({
            withoutNemId: false,
            jsConfig: {},
            showNemId: true,
            nemidResponse: '',
            nemid_js_endpoint: window.config.nemid_js_endpoint,
            //cprNumber_1: '',
            //cprNumber_2: '',
            //cprNumber: '',
            validationSuccessful: false,
            verifying: false,

            cprNumber_1_1: '',
            cprNumber_1_2: '',
            cprNumber_1_3: '',
            cprNumber_1_4: '',
            cprNumber_1_5: '',
            cprNumber_1_6: '',

            cprNumber_2_1: '',
            cprNumber_2_2: '',
            cprNumber_2_3: '',
            cprNumber_2_4: ''

        }),
        components: {
            ExpatVerification,
            NemidSignature,
            Loader
        },
        computed: {
            ...mapGetters([
                'getToken',
                'isVerified'
            ]),
            cprNumber: function(){
                // return this.cprNumber_1 + this.cprNumber_2
                return this.cprNumber_1_1 + this.cprNumber_1_2 + this.cprNumber_1_3 + this.cprNumber_1_4 + this.cprNumber_1_5 + this.cprNumber_1_6 + this.cprNumber_2_1 + this.cprNumber_2_2 + this.cprNumber_2_3 + this.cprNumber_2_4
            },
            cprDisabled: function() {
                //return this.cprNumber_1.length !== 6 || this.cprNumber_2.length !== 4
                return this.cprNumber_1_1.length !== 1 || this.cprNumber_1_2.length !== 1 || this.cprNumber_1_3.length !== 1 || this.cprNumber_1_4.length !== 1 || this.cprNumber_1_5.length !== 1 || this.cprNumber_1_6.length !== 1 || this.cprNumber_2_1.length !== 1 || this.cprNumber_2_2.length !== 1 || this.cprNumber_2_3.length !== 1 || this.cprNumber_2_4.length !== 1
            }
        },
        watch: {
            // cprNumber_1: function (val) {
            //     if (val.length > 6) {
            //         this.cprNumber_1 = val.slice(0, 6);
            //     }
            // },
            // cprNumber_2: function (val) {
            //     if (val.length > 4) {
            //         this.cprNumber_2 = val.slice(0, 4);
            //     }
            // }
        },
        methods: {
            createDate(){
                let today = new Date();
                let dd = today.getDate();
                let mm = today.getMonth()+1; //January is 0!
                let yyyy = today.getFullYear();
                let h = today.getHours();
                let m = today.getMinutes();
                let s = today.getSeconds();

                if(dd<10) {
                    dd = '0'+dd
                }

                if(mm<10) {
                    mm = '0'+mm
                }

                if(h<10) {
                    h = '0'+h
                }

                if(m<10) {
                    m = '0'+m
                }

                if(s<10) {
                    s = '0'+s
                }

                return yyyy + '-' + mm + '-' + dd + ' ' + h + ':' + m + ':' + '00';
            },
            success(response){
                this.nemidResponse = response;
                this.showNemId = false;
            },
            error(message) {
                this.$swal(message, [], 'error');
            },
            verifyPerson(){
                var self = this;
                this.verifying = true;
                axios({
                    method: 'POST',
                    url: window.config.apiUrl + 'api/nemid/validate-cpr',
                    cancelToken: window.AuthorizationCancelSource.token,
                    data: {
                        nemid_response: this.nemidResponse,
                        cpr: this.cprNumber
                    }
                }).then(response => {
                    this.validationSuccessful = true;
                    this.$store.dispatch('fetchUserData');
                    this.$root.$emit('verificationCompleted');

                    // this.$root.$emit('tab', 'occupation', false);
                }).finally((e) => {
                    this.verifying = false;
                });
            }
        },
        mounted(){
            if (this.expat) {
                this.withoutNemId = true;
            } else if (this.isVerified) {
                console.info('NemID client skipped');
            } else {
                window.axios.get('/nemid/javascript').then((response) => this.jsConfig = response.data);
            }
        }
    }
</script>

<style scoped>

</style>
